import { render, staticRenderFns } from "./ResultadosCliente.vue?vue&type=template&id=f8de2dac"
import script from "./ResultadosCliente.vue?vue&type=script&lang=js"
export * from "./ResultadosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports